// extracted by mini-css-extract-plugin
module.exports = {"text_hidden":"Slide_text_hidden__hEGJW"};